<template>
    <div class="faq-detail-box" ref="scrollboxWrapper" :class="{'box-overflow-hidden':callQuitWarning || callCommentInput}" >
        <div class="faq-detail-wrapper" ref="scrollBox" v-if="ajaxDone">
            <div class="faq-detail">
                <div class="faq-head">
                    <span class="f-type">常见问题</span>
                    <h3 class="f-title" v-text="faqInfo.Question"></h3>
                </div>
                <div class="faq-content padding-sets">
                    <div class="f-author flexBox">
                        <img class="avator" :src="'' + faqInfo.HeadPic" @error="$imgErr">
                        <div class="flexItem">
                            <p class="f-author-name" v-text="(faqInfo.OwnerEngName || faqInfo.OwnerName) ? faqInfo.OwnerEngName + ' ' + faqInfo.OwnerName : '未知用户'"></p>
                            <span class="f-update-last">更新于{{ faqInfo.UpdatedOn | timeAgo }}</span>
                        </div>
                        <a class="f-enterprise-wechat">
                            <img class="tel" src="/static/images/call-qywx.png" @click="actionEnterpriseChat(faqInfo.Question, faqInfo.OwnerEngName + ' ' + faqInfo.OwnerName, faqInfo.ChatList)">
                            <transition name="opacity-fade">
                                <div class="tooltip-wrap" @click="setTooltipRead" v-if="tooltipShow">
                                    <span class="tooltip">我是知识负责人，可以找我私聊<i class="k-close">&#10005;</i></span>
                                    <span class="bottom-trangle"></span>
                                </div>
                            </transition>
                        </a>
                    </div>
                    <div class="f-maintain" ref="fMaintain" :class="[$style['f-maintain'], {[$style['f-maintain-font-reset']]: resetClass}]" v-html="faqInfo.UnCopyContent"></div>
                    <div class="f-belongTo" v-show="faqInfo.KnowLedgeName">
                        <span>归属知识：</span><span class="f-knowledge" v-text="faqInfo.KnowLedgeName" @click="viewKnowledge(faqInfo.ParentKBInfoId)"></span>
                    </div>
                    <div class="f-view-count">
                        <span>{{ faqInfo.TotalViewCount | validCount }}人浏览</span>
                    </div>
                </div>
            </div>

            <!-- 对外话术 -->
            <div class="faq-copyable-text padding-sets" v-if="faqInfo.CopyContent">
                <div class="faq-copyable-text-head">
                    <span class="faq-copyable-text-tit">对外话术</span>
                    <span class="faq-copyable-text-btn" v-clipboard="faqInfo.CopyContent" @success="copyText('success')" @error="copyText('failure')">一键复制</span>
                </div>
                <article id="faq-copyable-text-body" ref="faqCopyText" class="faq-copyable-text-body" :class="{[$style['faq-copyable-font-reset']]: resetClass}" v-html="faqInfo.DisCopyContent"></article>
            </div>

            <!-- 常见相关问题列表 -->
            <div class="faq-recommend padding-sets" v-if="InterestList.length">
                <div class="recommend-tabs flexBox">
                    <span class="recommend-tab">相关常见问题</span>
                </div>
                <div class="recommend-lists recommend-interest-lists">
                    <section class="recommend-list" v-for="faq in InterestList" v-text="faq.Title" @click="viewFaq(faq)"></section>
                </div>
                <div class="recommend-load" @click="loadMore()" v-if="FIPageIndex < FIPageCount && prevAjaxEnd">查看更多</div>
                <loading-more v-if="callRelatedFaqLoading"></loading-more>
            </div>

            <!-- 评论列表区域 -->
            <div class='leave-divider'>
                <leave-list :commentListTitle='commentListTitle' :commentsTotalCount="commentsTotalCount" :commentsForPageCount="commentsForPageCount" :commentsList="commentsList" :checkMoreComment='checkMoreComment' @checkMoreCommentClick="checkMoreCommentClick" @deleteComment="deleteComment" @initCommentList="initCommentList" @refreshCommentList="refreshCommentList"></leave-list>
            </div>

            <!-- 评论退出提醒 -->
            <quit-message v-if='callQuitWarning' :messageTitle="messageTitle" :messageText="messageText" :queryBtn="queryBtn" @closeQuitWarning='closeQuitWarning' @eventContinue="eventContinue"></quit-message>

            <water-mark ref="watermark"></water-mark>
            <!-- 无权限页面 -->
            <unauthorize v-if="callUnauthorize" :unauthorizeType="unauthorizeType"></unauthorize>

            <!-- 互动问答--bar -->
            <releave-recover :knowledgeInfo="faqInfo"></releave-recover>
        </div>
    </div>
</template>

<script>

import { SEARCH, COMMON, COMMENTS } from '../api'
import commonMixin from '@/utils/commonMixin'
import { wxConfig } from '@/utils/wxConfig'
import store from '@/store/index'
import loadingMore from '@/components/loadingMore'
import waterMark from '../components/waterMark'
import unauthorize from './404/403.vue'
import leaveList from '@/components/leaveList'
import releaveRecover from '@/components/releaveRecover'
import quitMessage from '@/components/quitMessage'
import dsBridge from '../utils/jsbridge'

export default {
    name: 'faqDetail',
    mixins: [ commonMixin ],
    components: {
        waterMark, quitMessage, leaveList, releaveRecover, unauthorize, loadingMore
    },
    data() {
        return {
            KBInfoId: '',
            parentKBInfoId: '',

            lastScrollTop: 0,
            resetClass: false,  // 重置样式的判断变量
            tooltipShow: false,

            ajaxDone: false,
            callUnauthorize: false,
            unauthorizeType: '401',
            prevAjaxEnd: true,
            faqInfo: {
                HeadPic: '/static/images/default.png',
                OwnerEngName: '',
                OwnerName: '',
                TotalViewCount: '-'
            },

            // 常见相关问题
            FIPageIndex: 1,
            FIPageSize: 10,
            FIPageCount: 1,
            InterestList: [],

            // 发送评论区域变量
            callQuitWarning: false,  //用于显示退出确认弹窗
            toRouterPath: '',     //用于保存想退出当前页面并前往的路由
            // 退出确认弹窗的内容以及按钮文字
            messageTitle: '是否继续退出',
            messageText: '未提交内容将不会被保存,是否继续退出?',
            queryBtn: '继续退出',

            // 互动问答区域变量
            commentsList: [],
            commentListTitle: '互动问答',
            commentsTotalCount: 0,//一共多少条评论(含子回复)
            commentsForPageCount: 0,//一共多少条主评论
            leavePageIndex: 1,
            leavePageSize: 100,

            checkMoreComment: true,//是否显示查看更多  点击后直接调用滚动加载更多并隐藏查看更多
            leavePrevAjaxEnd: true,//加载更多是否完成
            callRelatedFaqLoading: false, // 是否显示相关常见问题loading
        }
    },
    computed: {
        FICACHE() {
            return this.$store.getters.GET_FI_CACHE
        },
        authType() {
            return localStorage.AUTH_TYPE
        },
        inputContent() {
            return store.getters.GET_InputContent
        },
        callCommentInput() {
            return store.getters.GET_CallCommentInput
        },
    },
    mounted() {
        this.initData(this.$route.params.uuid.split('&')[0])
        wxConfig()
    },
    activated() {
        // 不管三七二十一，先加载一次水印再说(为了防止测试的这样一种骚操作：在打开图片预览的时候分享网页给别人，然后自己再打开这个分享，这个时候水印已经被打在图片预览组件里，页面是没有水印的，但是打开分享，图片预览组件是不会重新打开的，所以我重新渲染一次水印就OK了)
        setTimeout(() => {  // 彻底关闭之后重新绘画
            this.$refs.watermark && this.$refs.watermark.initWaterMark()
        }, 300)
        this.KBInfoId !== this.$route.params.uuid.split('&')[0]? this.initData(this.$route.params.uuid.split('&')[0]) : this.$refs.scrollboxWrapper.scrollTop = this.lastScrollTop
    },
    methods: {
        // 打电话
        callPhone(data) {
            if (this.authType === 'WECHAT') {
                window.location.href = "tel:" + data;
            } else if (this.authType === 'TOOLKIT') {
                if (dsBridge.call("toolkit.getTokenSyn")) {
                    let phone = "toolkit://dial?phone=" + data;
                    dsBridge.call("common.dialSyn", phone);
                }
            } else if(this.authType === 'APOLLO') {
                dsBridge.call("ApolloApp.invokeAsyn",
                    {
                        "methodName": "callMobile",
                        "params": {
                            "tel": data
                        }
                    }
                )
            }
        },
        copyText(status) {  // 一键复制
            store.commit('SetAndCallToast', status === 'success' ? '复制成功' : '复制失败')
            // 埋点数据
            COMMON.CopyTextReport({
                KBInfoId: this.$route.params.uuid.split('&')[0],
                Name: this.faqInfo.Question
            }).then( (res) => {})
        },

        // 滚动加载
        scrollHandler() {
            let scrollTop = this.$refs.scrollboxWrapper.scrollTop
            let visible_h = this.$refs.scrollboxWrapper.clientHeight
            let scrollBox_h = this.$refs.scrollBox.clientHeight

            if (scrollTop + visible_h >= scrollBox_h) {
                this.loadMoreLeave()
            }
        },
        initData(KBInfoId) {
            window.addEventListener("popstate", this.hideVideo, false)
            this.KBInfoId = KBInfoId
            this.$refs.scrollboxWrapper.scrollTop = 0
            this.FIPageIndex = 1
            this.ajaxDone = false
            this.callUnauthorize = false
            store.commit('SET_CallCommentInput', false)
            // 获取详情
            this.initDetail()
            // 获取评论列表
            this.initCommentList()
        },
        initDetail() {
            if (!localStorage.tooltipShow_1121) {
                // reset to false 再执行浮层动画
                this.tooltipShow = false
            }
            SEARCH.GetFaqDetail({
                KBInfoId: this.KBInfoId
            }).then((res) => {
                this.ajaxDone = true
                this.$refs.scrollboxWrapper.addEventListener('scroll', this.scrollHandler, false)
                if (res.Code == 401) {
                    this.unauthorizeType = '401'
                    this.callUnauthorize = true
                } else if (res.Code == 404) {
                    this.unauthorizeType = '404'
                    this.callUnauthorize = true
                } else if (res.Code == 200) {

                    this.faqInfo = res.Data
                    this.$nextTick( () => {
                        // 重置Faq正文内容字体&字号样式
                        this.resetFontStyle('fMaintain')
                        // 重置对外话术内容字体&字号样式
                        this.resetFontStyle('faqCopyText')

                        // 只有在第一次查看问题/知识点详情时，才展示tooltip
                        if (!localStorage.tooltipShow_1121) {
                            this.tooltipShow = true
                        }
                    })
                    
                    this.parentKBInfoId = res.Data.ParentKBInfoId
                    this.initInterestData(res.Data.ParentKBInfoId)

                    this.getLogId()
                }
            }).catch((error) => {
                this.ajaxDone = true;
            })
        },
        resetFontStyle(ref) {  // 重置正文的字体字号样式

            // 需要被重置样式的DOM节点
            if (!this.$refs[ref]) return
            let nodes = this.$refs[ref].childNodes

            for (let i = 0; i < Array.from(nodes).length; i++) {
                this.deepLoop(nodes[i])
            }

            // using class `f-maintain-font-reset` to overwrite unset property
            this.resetClass = true
        },
        deepLoop(nodes) {
            if (nodes.nodeType === 1) {
                // console.log(nodes, nodes.childNodes)
                // reset `font` property to `unset`
                nodes.style.fontSize = 'unset'
                nodes.style.fontFamily = 'unset'
                if (nodes.childNodes.length > 0) {
                    for (let j = 0; j < nodes.childNodes.length; j++) {
                        this.deepLoop(nodes.childNodes[j])
                    }
                }
            }
        },
        callQYWX() {  // 调用企业微信
            
        },
        setTooltipRead() {  // 关闭tooltip 并设置为已读
            this.tooltipShow = false
            // set tooltip showing flag to local
            localStorage.tooltipShow_1121 = 'viewed'
        },
        initInterestData(ParentKBInfoId) {
            COMMON.GetFaqInterestsByUUID({
                KBInfoId: this.KBInfoId,
                ParentKBInfoId: ParentKBInfoId,
                PageIndex: this.FIPageIndex,
                PageSize: this.FIPageSize
            }).then((res) => {
                if (res.Code == 200) {
                    if (res.Data != null && res.Data.List != null) {
                        this.InterestList = res.Data.List || [];
                        this.FIPageCount = Math.ceil(res.Data.TotalCount / this.FIPageSize)
                    } else {
                        this.InterestList = []
                    }
                    setTimeout(() => {  // 彻底关闭之后重新绘画
                        this.$refs.watermark && this.$refs.watermark.initWaterMark()
                    }, 300)
                }

            })
        },
        loadMore() {
            if (!this.prevAjaxEnd) return
            if (this.FIPageIndex >= this.FIPageCount) return
            this.prevAjaxEnd = false
            this.callRelatedFaqLoading = true
            store.commit('SET_LOADING_POSITION', 'bottom')
            COMMON.GetFaqInterestsByUUID({
                KBInfoId: this.KBInfoId,
                ParentKBInfoId: this.parentKBInfoId,
                PageIndex: ++this.FIPageIndex,
                PageSize: this.FIPageSize
            }).then((res) => {
                if (res.Data != null) {
                    this.InterestList = this.InterestList.concat(res.Data.List)
                    this.prevAjaxEnd = true
                    this.callRelatedFaqLoading = false
                    store.commit('SET_LOADING_POSITION', 'middle')
                }
            }).catch(() => {
                this.prevAjaxEnd = true
                this.callRelatedFaqLoading = false
                store.commit('SET_LOADING_POSITION', 'middle')
            })
        },

        // 评论区方法
        //初始化评论列表
        initCommentList() {
            this.leavePageIndex = 1
            this.commentsTotalCount = 0
            this.commentsList = []
            COMMENTS.GetCommentList({
                "KBInfoId": this.KBInfoId,
                "PageIndex": this.leavePageIndex,
                "PageSize": this.leavePageSize,
            }).then((res) => {
                if (res && res.Data && res.Data.List && res.Data.List.length > 0) {
                    this.commentsList = res.Data.List;
                    // 用于显示在页面上的总评论数(主评论数+子评论数)
                    this.commentsTotalCount = res.Data.TotalCount;
                    // 用于分页的评论总数(主评论数)
                    this.commentsForPageCount = res.Data.ForPageCount;
                    // 当  总页数小于等于1时 【查看更多评论按钮】  消失
                    this.checkMoreComment = !(Math.ceil(this.commentsForPageCount / this.leavePageSize) <= 1)

                    setTimeout(() => {  // 彻底关闭之后重新绘画
                        this.$refs.watermark && this.$refs.watermark.initWaterMark()
                    }, 300)
                }
            }).catch((error) => {
                console.log(error);
            })
        },
        // 点击查看更多按钮加载第二页评论
        checkMoreCommentClick() {
            this.checkMoreComment = false
            this.loadMoreLeave()
        },
        //加载更多评论
        loadMoreLeave(data) {
            // 当  查看更多按钮在的时候   禁止滚动加载
            if (this.checkMoreComment) return
            // 当  查看更多按钮消失后，  当 当前页数 大于等于  总页数时，  禁止滚动加载
            if (this.leavePageIndex >= Math.ceil(this.commentsForPageCount / this.leavePageSize)) return
            // 当上一次滚动加载未完成时，禁止滚动加载
            if (!this.leavePrevAjaxEnd) return

            this.leavePrevAjaxEnd = false;
            store.commit('SET_LOADING_POSITION', 'bottom')
            COMMENTS.GetCommentList({
                "KBInfoId": this.KBInfoId,
                "PageIndex": ++this.leavePageIndex,
                "PageSize": this.leavePageSize,
            }).then((res) => {
                store.commit('SET_LOADING_POSITION', 'middle')
                if (res && res.Data && res.Data.List && res.Data.List.length > 0) {
                    this.commentsList = this.commentsList.concat(res.Data.List);
                    this.commentsTotalCount = res.Data.TotalCount;
                    this.commentsForPageCount = res.Data.ForPageCount;

                    setTimeout(() => {  // 彻底关闭之后重新绘画
                        this.$refs.watermark && this.$refs.watermark.initWaterMark()
                    }, 300)
                }
                this.leavePrevAjaxEnd = true;
            }).catch((error) => {
                this.leavePrevAjaxEnd = true;
                store.commit('SET_LOADING_POSITION', 'middle')
            })
        },
        //新增评论到列表中，更新评论列表
        refreshCommentList(replyerInfo, commentInfo, commentIndex) {
            // 更新 评论数组 ,
            if (!commentInfo) {
                // 在数组第一条添加新评论
                this.commentsList.unshift(replyerInfo)

                // 更新评论总数
                this.commentsTotalCount += 1
                this.commentsForPageCount += 1

                // 添加了新评论，分页排序错位，如果评论总数大于等于十条（分页条数）则将最后一条评论删除，在加载下一页的时候会加载到这条删除的而不会出现重复。
                if (this.commentsForPageCount >= this.pageSize) this.commentsList.pop()
            } else {
                // 将新回复添加到子评论列表中，不用删除最后一条，因为没有分页
                this.commentsList[commentIndex].ReplyList ? this.commentsList[commentIndex].ReplyList.push(replyerInfo) : this.commentsList[commentIndex].ReplyList = [replyerInfo]
                this.commentsTotalCount += 1;
            }
            //发布成功  关闭清空输入框等
            store.commit('SET_CallCommentInput', false)
            store.commit('SET_InputPlaceholder', '写下我的留言或提问...')
        },

        viewKnowledge(uuid) {
            // store.commit('SET_FI_CACHE', {
            //     uuid: this.KBInfoId,
            //     detail: this.faqInfo,
            //     FIList: this.InterestList
            // })
            this.$router.push({name: 'knowledge', params: {uuid: uuid}})
        },
        //删除评论
        deleteComment(deleteIndex) {
            // 将对应评论的  IsDel 属性设置为true 即可删除
            this.commentsList[deleteIndex].IsDel = true
            this.commentsTotalCount--
            this.commentsForPageCount--
        },

        // 确认退出弹框 cancle按钮
        closeQuitWarning() {
            this.callQuitWarning = false
        },
        // 确认退出弹框 continue按钮
        eventContinue() {
            // 关闭输入框，清除掉 inputContent ，所以继续操作的时候不会阻止路由跳转了
            store.commit('SET_InputContent', false)
            store.commit('SET_CallCommentInput', false)
            // 关闭确认框
            this.callQuitWarning = false
            // 跳转路由
            setTimeout(() => {
                this.$router.push(this.toRouterPath)
            }, 300)

        },
        viewFaq(faq) {
            // store.commit('SET_FI_CACHE', {
            //     uuid: this.KBInfoId,
            //     detail: this.faqInfo,
            //     FIList: this.InterestList
            // })
            //--------埋点-------
            try{
                let data = {
                    LogId:this.LogId,
                    FAQId:faq.KBInfoId,
                    FAQName:faq.Title
                }
                COMMON.UpdateKBDetailViewData(data).then(()=>{
                    this.$router.push({name: 'faq', params: {uuid: faq.KBInfoId}})
                })
            }
            catch (e) {
                console.log(e);
                this.$router.push({name: 'faq', params: {uuid: faq.KBInfoId}})
            }
            //-------------------

        },

        // 在退出路由的时候需要进行的一些骚操作，反正有用
        resetPage() {
            store.commit('SET_CallCommentInput', false)
            this.callQuitWarning = false
            this.callUnauthorize = false
            localStorage.faq_uuid = this.KBInfoId
            this.$refs.scrollboxWrapper.removeEventListener('scroll', this.scrollHandler)
        },


        //获取logid  埋点方法
        getLogId(){
            try{
                let data = {
                    KBInfoId:this.KBInfoId,
                    KBName:this.faqInfo.Question
                }
                COMMON.AddKBDetailViewData(data).then((res)=>{
                    this.LogId = res.Data.LogId
                })
            }
            catch (e) {
                console.log(e);
            }
        }
    },
    //仅路由参数变化（从一个知识点跳转到另一个知识点）
    beforeRouteUpdate(to, from, next) {
        //先判断是否有输入过评论内容或上传过图片)
        if (this.inputContent) {
            //如果有内容则不退出路由并弹出退出评论确认框
            this.callQuitWarning = true
            this.toRouterPath = to.fullPath
            next(false)
        } else {
            this.initData(to.params.uuid)
            next()
        }
    },
    beforeRouteLeave(to, from, next) {
        this.lastScrollTop = this.$refs.scrollboxWrapper.scrollTop
        //先判断是否有输入过评论内容或上传过图片)
        if (this.inputContent) {
            //如果有内容则不退出路由并弹出退出评论确认框
            this.callQuitWarning = true
            this.toRouterPath = to.path
            next(false)
        } else {
            this.resetPage()
            next()
        }
    }
}
</script>

<style lang="scss" type="text/scss" scoped>
    .faq-detail-box {
        position: relative;
        height: 100%;
        overflow: scroll;

        .faq-detail-wrapper {
            position: relative;
            padding-bottom: j(300);
        }
    }
    .box-overflow-hidden{
        overflow: hidden;
    }
    .faq-head {
        position: relative;
        padding: j(40) 0 j(30);
        width: j(650);
        margin: 0 auto;
        font-size: 0;
        border-bottom: 1px solid #f0f1f2;

        .f-type {
            width: 100%;
            font-size: j(24);
            font-weight: bold;
            color: #9b9da9;
        }

        .f-title {
            margin-top: j(10);
            font-size: j(38);
            color: #363c54;
            word-break: break-word;
            width: 100%;
        }
    }

    .faq-content {
        margin-top: j(25);
        padding-bottom: j(40);
        font-size: j(32);
        color: #363c54;

        .f-author {
            // font-size: j(32);
            .avator {
                margin-right: j(20);
                width: j(80);
                height: j(80);
                border-radius: 50%;
            }

            .flexItem {
                font-size: 0;
            }

            .f-author-name {
                font-size: j(32);
                font-weight: 700;
            }

            .f-update-last {
                margin-bottom: j(5);
                display: inline-block;
                font-size: j(24);
                color: #9b9da9;
            }

            .tel {
                width: j(60);
                height: j(60);
                display: block;
            }

            .f-enterprise-wechat {
                position: relative;
                margin-left: j(20);
                font-size: 0;
            }

            .tooltip-wrap {
                position: absolute;
                bottom: j(30 + 60); right: j(-24);
                .tooltip {
                    display: block;
                    width: j(480);
                    padding: j(18) 0;
                    font-size: j(28);
                    color: #fff;
                    background: #00bebe;
                    text-align: center;
                    border-radius: j(48);
                }
                .k-close {
                    font-style: normal;
                    margin-left: j(20);
                }
                .bottom-trangle {
                    position: absolute;
                    right: j(39);
                    top: 100%;
                    border-top: j(15) solid #00bebe;
                    border-left: j(15) solid transparent;
                    border-right: j(15) solid transparent;
                    width: 0; height: 0;
                }
            }
            .opacity-fade-enter {
                opacity: 0;
                transform: translateY(j(30));
            }
            .opacity-fade-enter-active {
                transition: all .5s ease 1s;
            }
        }

        .f-maintain {
            font-weight: 400;
            margin-top: j(30);
            padding-bottom: j(40);
            word-break: break-word;
            position: relative;

            &:after {
                @include thin-bb(#f1f2f3);
            }
        }

        .f-belongTo {
            margin-top: j(40);
            font-size: j(28);
            color: #9b9da9;
        }
        .f-view-count {
            margin-top: j(50);
            font-size: j(24);
            color: #9b9da9;
        }

        .f-knowledge {
            color: #00bcbc;
        }
    }

    .faq-recommend {
        border-top: j(20) solid #f7f7f8;
        font-size: j(30);
        color: #363c54;

        .recommend-tabs {
            position: relative;
            height: j(110);
            line-height: j(110);
            font-size: j(28);

            &:after {
                @include thin-bb(#f1f2f3);
            }

            .recommend-tab {
                height: 100%;
                color: #9b9da9;
                box-sizing: border-box;
                transition: color .3s linear;
            }
        }

        .recommend-lists {
            section {
                margin-top: j(40);
                &:last-child {
                    margin-bottom: j(40);
                }
            }
        }

        .recommend-load {
            background-color: #F0FCFC;
            height: j(60);
            width: j(182);
            margin: j(80) auto;
            font-size: j(28);
            color: #00bebe;
            border-radius: j(28);
            display: flex;
            align-items: center;
            justify-content: center;
        }
    }

    .faq-copyable-text {
        border-top: j(20) solid #f7f7f8;
        padding-bottom: j(50);
        padding-top: j(50);

        .faq-copyable-text-head {
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin-bottom: j(50);
        }

        .faq-copyable-text-tit {
            font-size: j(38);
            font-weight: 700;
            color: rgba(54, 60, 84, 1);
        }

        .faq-copyable-text-btn {
            font-size: j(28);
            color: rgba(0, 188, 188, 1);
        }

        .faq-copyable-text-body {
            font-size: j(32);
            color: rgba(54, 60, 84, 1);
            word-break: break-word;
            overflow: hidden;
        }

        #faq-copyable-text-input {
            position: absolute;
            opacity: 0;
        }
    }

    .padding-sets {
        padding-left: j(50);
        padding-right: j(50);
    }

    .leave-divider {
        border-top: j(20) solid #F7F7F8;
    }
</style>
<style lang="scss" type="text/scss" module>
    .f-maintain {
        overflow-x: auto;

        p + p {
            margin-top: j(20);
        }

        p > br {
            display: none;
        }

        img, video {
            display: block;
            width: 100% !important;
        }
    }

    .f-title font {
        color: #363c54 !important;
    }
    
    .f-maintain-font-reset, .faq-copyable-font-reset {
        // important 覆盖行内样式 unset
        font-size: j(30)!important;
    }
</style>



// WEBPACK FOOTER //
// src/views/faqDetail.vue